import React from 'react';

const OfflineIllustration = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="176" height="176" viewBox="0 0 176 176">
      <defs>
        <linearGradient id="prefix__a" x1="0%" x2="97.875%" y1="100%" y2="100%">
          <stop offset="0%" stopColor="#DDE5E9" />
          <stop offset="100%" stopColor="#CAD2D6" />
        </linearGradient>
      </defs>
      <g fill="none">
        <circle cx="88" cy="88" r="88" fill="url(#prefix__a)" />
        <path
          fill="#FFF"
          d="M88.493 109c2.24 0 3.9 1.833 3.997 4 .096 2.16-1.906 4-3.997 4-2.24 0-3.9-1.833-3.997-4-.096-2.16 1.907-4 3.997-4zM55.037 63.544c.781-.78 2.048-.78 2.829 0l48.083 48.083c.78.781.78 2.048 0 2.829-.781.78-2.047.78-2.829 0L88.67 100l-.176-.001c-3.41 0-6.603 1.313-9.011 3.63-1.592 1.531-4.124 1.482-5.656-.11-1.531-1.592-1.482-4.124.11-5.656 2.242-2.157 4.914-3.778 7.83-4.762l-6.112-6.114c-2.73 1.35-5.246 3.132-7.456 5.297-1.578 1.546-4.11 1.52-5.656-.058-1.546-1.578-1.52-4.11.057-5.656 2.17-2.126 4.573-3.963 7.155-5.482l-5.81-5.812c-2.549 1.663-4.938 3.59-7.128 5.761-1.57 1.555-4.102 1.544-5.657-.025-1.555-1.569-1.544-4.102.025-5.657 2.175-2.155 4.516-4.107 6.998-5.84l-3.145-3.143c-.78-.781-.78-2.048 0-2.829zm36.505 28.677c4.344.633 8.353 2.607 11.51 5.645 1.592 1.531 1.64 4.064.109 5.656-.052.054-.106.106-.16.157L91.541 92.221zM88.493 76c9.837 0 19.075 3.862 25.948 10.623 1.574 1.55 1.595 4.082.046 5.657-1.55 1.575-4.082 1.595-5.657.046C103.439 87.022 96.21 84 88.493 84c-1.619 0-3.216.133-4.78.392l-6.605-6.606C80.733 76.616 84.565 76 88.493 76zm0-16c14.144 0 27.418 5.571 37.273 15.321 1.57 1.554 1.584 4.086.03 5.657-1.553 1.57-4.086 1.584-5.656.03C111.767 72.725 100.509 68 88.493 68c-6.162 0-12.124 1.243-17.6 3.57l-6.028-6.026C72.087 61.944 80.138 60 88.493 60z"
          opacity=".607"
        />
      </g>
    </svg>
  );
};

export default OfflineIllustration;
